/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CaseActivityActorType = {
    Staff: 'staff',
    Participant: 'participant',
    System: 'system',
} as const;
export type CaseActivityActorType = typeof CaseActivityActorType[keyof typeof CaseActivityActorType];


export function instanceOfCaseActivityActorType(value: any): boolean {
    for (const key in CaseActivityActorType) {
        if (Object.prototype.hasOwnProperty.call(CaseActivityActorType, key)) {
            if (CaseActivityActorType[key as keyof typeof CaseActivityActorType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CaseActivityActorTypeFromJSON(json: any): CaseActivityActorType {
    return CaseActivityActorTypeFromJSONTyped(json, false);
}

export function CaseActivityActorTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaseActivityActorType {
    return json as CaseActivityActorType;
}

export function CaseActivityActorTypeToJSON(value?: CaseActivityActorType | null): any {
    return value as any;
}

export function CaseActivityActorTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): CaseActivityActorType {
    return value as CaseActivityActorType;
}

